
import { FaHandsHelping as Like } from "react-icons/fa";
import { iProject, ProjectContext } from "../../context/ProjectContext";
import { useContext } from "react";
import PostStyle from "./postStyle";
import RenderIcon from "../RenderIcon";


export interface iPosts {
  projects: iProject[];
}

function Post({ projects }: iPosts) {
  const { joinProject } = useContext(ProjectContext);

  return (
    <PostStyle className="container">
      <ul>
        {projects.map((project: iProject) => (
          <li key={project.id}>
            <div className="containerImgPostAndTechs">
              <img src={project.projectImg} alt="imagem padrão" />
              <div className="containerTechs">
                <RenderIcon arrTechs={project.techs} />
              </div>
            </div>
            <div className="containerInfoPost">
              <div className="containerUserPost">
                <div className="projectNameStyle">
                  <h2>{project.name}</h2>
                </div>
                <div className="infoUser">
                  <h2>{project.admin.adminName}</h2>
                  <p>{project.admin.adminLevel}</p>
                </div>
              </div>
              <div className="containerDescription">
                <p>{project.description}</p>

                <button onClick={() => joinProject(project.id)}>
                  Quero Ajudar <Like />
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </PostStyle>
  );
}

export default Post;
